import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard] ,
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'login',
    loadChildren: () =>
      import('../app/features/Login/login.module').then((m) => m.LoginModule),
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'orders-create',
    loadChildren: () =>
      import('../app/features/orders-create/orders-create.module').then((m) => m.OrdersCreateModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'orders-assignement',
    loadChildren: () =>
      import('../app/features/orders-assignement/orders-assignement.module').then((m) => m.OrdersAssignementModule),
    canActivate: [AuthGuard],
    data: {  allowedUserTypes: [3, 5] }
  },
  {
    path: 'orders-support',
    loadChildren: () =>
      import('../app/features/orders-support/orders-support.module').then((m) => m.OrdersSupportModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'partners',
    loadChildren: () =>
      import('../app/features/partners/partners.module').then((m) => m.PartnersModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'riders',
    loadChildren: () =>
      import('../app/features/riders/riders.module').then((m) => m.RidersModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../app/features/users/users.module').then((m) => m.UsersModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'chat',
    loadChildren: () =>
      import('../app/features/chat/chat.module').then((m) => m.ChatModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  {
    path: 'exported-data',
    loadChildren: () =>
      import('../app/features/exported-data/exported-data.module').then((m) => m.ExportedDataModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3] }
  },
  {
    path: 'manual-services',
    loadChildren: () =>
      import('../app/features/manual-services/manual-services.module').then((m) => m.ManualServicesModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3, 5] }
  },
  // {
  //   path: 'schedule-management',
  //   loadChildren: () =>
  //     import('../app/features/schedule/schedule.module').then((m) => m.ScheduleModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'payments-support',
    loadChildren: () =>
      import('../app/features/payments-support/payments-support.module').then((m) => m.PaymentsSupportModule),
    canActivate: [AuthGuard],
     data: { allowedUserTypes: [3] }
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}